var _g, _path, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0H8C5.23858 0 3 2.23857 3 5V19C3 21.7614 5.23858 24 8 24H22C24.7614 24 27 21.7614 27 19V5C27 2.23857 24.7614 0 22 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_4810)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2667 11.1526C20.034 10.6219 18.9554 9.89398 18.0306 8.96958C17.1062 8.04519 16.3782 6.96621 15.8476 5.73353C15.6439 5.26111 15.4801 4.77549 15.3546 4.27761C15.3137 4.11483 15.1678 4.00024 15 4.00024C14.8322 4.00024 14.6863 4.11483 14.6453 4.27761C14.5198 4.77549 14.3561 5.26065 14.1524 5.73353C13.6218 6.96621 12.8938 8.04519 11.9694 8.96958C11.045 9.89398 9.966 10.6219 8.73332 11.1526C8.26088 11.3563 7.77526 11.52 7.27737 11.6455C7.11458 11.6864 7 11.8323 7 12.0001C7 12.1679 7.11458 12.3139 7.27737 12.3548C7.77526 12.4803 8.26043 12.644 8.73332 12.8477C9.966 13.3783 11.0445 14.1063 11.9694 15.0306C12.8943 15.955 13.6218 17.034 14.1524 18.2667C14.3561 18.7391 14.5198 19.2247 14.6453 19.7226C14.6863 19.8854 14.8322 20 15 20C15.1678 20 15.3137 19.8854 15.3546 19.7226C15.4801 19.2247 15.6439 18.7396 15.8476 18.2667C16.3782 17.034 17.1062 15.9555 18.0306 15.0306C18.955 14.1063 20.034 13.3783 21.2667 12.8477C21.7391 12.644 22.2247 12.4803 22.7226 12.3548C22.8854 12.3139 23 12.1679 23 12.0001C23 11.8323 22.8854 11.6864 22.7226 11.6455C22.2247 11.52 21.7395 11.3563 21.2667 11.1526Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_4810",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C15.1678 4 15.3138 4.11457 15.3547 4.27734C15.4802 4.77523 15.6439 5.26097 15.8476 5.7334C16.3783 6.96597 17.1062 8.0449 18.0305 8.96925C18.9554 9.89362 20.0339 10.6217 21.2666 11.1523C21.7395 11.356 22.2247 11.5198 22.7226 11.6453C22.8854 11.6862 23 11.832 23 11.9997C23 12.1675 22.8854 12.3135 22.7226 12.3545C22.2247 12.48 21.739 12.6437 21.2666 12.8474C20.0339 13.378 18.9549 14.1059 18.0305 15.0303C17.1062 15.9551 16.3783 17.0337 15.8476 18.2663C15.6439 18.7392 15.4802 19.2245 15.3547 19.7224C15.3138 19.8852 15.1678 19.9997 15 19.9997C14.8322 19.9997 14.6862 19.8852 14.6453 19.7224C14.5198 19.2245 14.3561 18.7388 14.1523 18.2663C13.6217 17.0337 12.8943 15.9546 11.9695 15.0303C11.0446 14.1059 9.96605 13.378 8.7334 12.8474C8.26051 12.6437 7.77524 12.48 7.27735 12.3545C7.11458 12.3135 7 12.1675 7 11.9997C7.00005 11.832 7.11462 11.6862 7.27735 11.6453C7.77524 11.5198 8.26096 11.356 8.7334 11.1523C9.96607 10.6217 11.0451 9.89362 11.9695 8.96925C12.8938 8.0449 13.6217 6.96597 14.1523 5.7334C14.3561 5.26052 14.5198 4.77523 14.6453 4.27734C14.6862 4.11456 14.8322 4 15 4Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C15.1678 4 15.3138 4.11457 15.3547 4.27734C15.4802 4.77523 15.6439 5.26097 15.8476 5.7334C16.3783 6.96597 17.1062 8.0449 18.0305 8.96925C18.9554 9.89362 20.0339 10.6217 21.2666 11.1523C21.7395 11.356 22.2247 11.5198 22.7226 11.6453C22.8854 11.6862 23 11.832 23 11.9997C23 12.1675 22.8854 12.3135 22.7226 12.3545C22.2247 12.48 21.739 12.6437 21.2666 12.8474C20.0339 13.378 18.9549 14.1059 18.0305 15.0303C17.1062 15.9551 16.3783 17.0337 15.8476 18.2663C15.6439 18.7392 15.4802 19.2245 15.3547 19.7224C15.3138 19.8852 15.1678 19.9997 15 19.9997C14.8322 19.9997 14.6862 19.8852 14.6453 19.7224C14.5198 19.2245 14.3561 18.7388 14.1523 18.2663C13.6217 17.0337 12.8943 15.9546 11.9695 15.0303C11.0446 14.1059 9.96605 13.378 8.7334 12.8474C8.26051 12.6437 7.77524 12.48 7.27735 12.3545C7.11458 12.3135 7 12.1675 7 11.9997C7.00005 11.832 7.11462 11.6862 7.27735 11.6453C7.77524 11.5198 8.26096 11.356 8.7334 11.1523C9.96607 10.6217 11.0451 9.89362 11.9695 8.96925C12.8938 8.0449 13.6217 6.96597 14.1523 5.7334C14.3561 5.26052 14.5198 4.77523 14.6453 4.27734C14.6862 4.11456 14.8322 4 15 4Z",
    fill: "url(#paint0_linear_1399_4810)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_4810)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55603 16.5083C7.4047 17.1648 9.52949 15.9339 10.3019 13.7589C11.0743 11.5839 10.2018 9.28857 8.35316 8.63207C6.5045 7.97556 4.3797 9.20652 3.6073 11.3815C2.83489 13.5565 3.70737 15.8518 5.55603 16.5083Z",
    fill: "#FFE432"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7636 9.33724C16.3034 9.33724 18.3622 7.23314 18.3622 4.63761C18.3622 2.04208 16.3034 -0.0620117 13.7636 -0.0620117C11.2239 -0.0620117 9.16504 2.04208 9.16504 4.63761C9.16504 7.23314 11.2239 9.33724 13.7636 9.33724Z",
    fill: "#FC413D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9767 24.3669C14.6279 24.2373 16.641 21.3481 16.4731 17.9136C16.3052 14.4792 14.0199 11.8 11.3688 11.9296C8.71757 12.0592 6.70446 14.9485 6.87236 18.3829C7.04025 21.8174 9.32556 24.4965 11.9767 24.3669Z",
    fill: "#00B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9767 24.3669C14.6279 24.2373 16.641 21.3481 16.4731 17.9136C16.3052 14.4792 14.0199 11.8 11.3688 11.9296C8.71757 12.0592 6.70446 14.9485 6.87236 18.3829C7.04025 21.8174 9.32556 24.4965 11.9767 24.3669Z",
    fill: "#00B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6315 22.2892C16.8541 20.9369 17.449 17.8571 15.9602 15.4103C14.4715 12.9634 11.4628 12.0761 9.2402 13.4284C7.0176 14.7807 6.4227 17.8605 7.91146 20.3073C9.40023 22.7542 12.4089 23.6415 14.6315 22.2892Z",
    fill: "#00B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6151 14.5999C26.1133 14.5999 28.1384 12.6498 28.1384 10.2442C28.1384 7.83855 26.1133 5.88843 23.6151 5.88843C21.117 5.88843 19.0918 7.83855 19.0918 10.2442C19.0918 12.6498 21.117 14.5999 23.6151 14.5999Z",
    fill: "#3186FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7785 14.0945C6.07869 15.8437 9.43901 15.2949 11.284 12.8688C13.129 10.4427 12.76 7.05794 10.4598 5.30877C8.15959 3.55959 4.79927 4.10835 2.95428 6.53447C1.1093 8.96058 1.47831 12.3453 3.7785 14.0945Z",
    fill: "#FBBC04"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5647 16.68C18.3103 18.5676 21.9496 18.0418 23.6933 15.5055C25.4371 12.9692 24.625 9.38301 21.8794 7.49542C19.1339 5.60783 15.4946 6.13368 13.7509 8.66994C12.0071 11.2062 12.8192 14.7924 15.5647 16.68Z",
    fill: "#3186FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5561 3.42396C21.2546 4.37363 20.3571 6.22007 18.5515 7.54812C16.7458 8.87617 14.7158 9.18292 14.0173 8.23325C13.3188 7.2836 14.2163 5.43714 16.022 4.10909C17.8276 2.78105 19.8576 2.4743 20.5561 3.42396Z",
    fill: "#749BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8225 7.9703C17.6149 5.38018 18.5734 1.8733 16.9632 0.137466C15.3531 -1.59836 11.7841 -0.90582 8.9917 1.68431C6.19926 4.27443 5.24081 7.78131 6.85093 9.51714C8.46106 11.253 12.03 10.5604 14.8225 7.9703Z",
    fill: "#FC413D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1399_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09822 17.2737C10.7579 18.4615 12.6633 18.642 13.3541 17.6768C14.0449 16.7117 13.2595 14.9663 11.5998 13.7785C9.94016 12.5906 8.03472 12.4101 7.34392 13.3753C6.65312 14.3404 7.43855 16.0858 9.09822 17.2737Z",
    fill: "#FFEE48"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1399_4810",
    x: 0.3,
    y: 0,
    width: 29.4,
    height: 30.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1399_4810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1399_4810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1399_4810",
    x: 2.09635,
    y: 7.22562,
    width: 9.71649,
    height: 10.6891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.614913,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1399_4810",
    x: 3.21949,
    y: -6.00756,
    width: 21.0884,
    height: 21.2904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.97277,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1399_4810",
    x: 1.808,
    y: 6.87087,
    width: 19.7297,
    height: 22.5549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52715,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1399_4810",
    x: 1.808,
    y: 6.87087,
    width: 19.7297,
    height: 22.5549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52715,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1399_4810",
    x: 2.0375,
    y: 7.7416,
    width: 19.7971,
    height: 20.2345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52715,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1399_4810",
    x: 14.2887,
    y: 1.08536,
    width: 18.653,
    height: 18.3176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.40153,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1399_4810",
    x: -2.57268,
    y: -0.0673103,
    width: 19.3836,
    height: 19.5378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17648,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1399_4810",
    x: 8.94467,
    y: 2.47543,
    width: 19.555,
    height: 19.2246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.94368,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1399_4810",
    x: 10.3018,
    y: -0.606278,
    width: 13.9696,
    height: 12.8698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.73924,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1399_4810",
    x: 3.13135,
    y: -3.75684,
    width: 17.5508,
    height: 17.1683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.46899,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1399_4810",
    x: 3.45651,
    y: 9.1185,
    width: 13.7842,
    height: 12.8151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81813,
    result: "effect1_foregroundBlur_1399_4810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1399_4810",
    x1: 11.5483,
    y1: 14.7052,
    x2: 19.8584,
    y2: 7.69898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4893FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4893FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776981,
    stopColor: "#969DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD99FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiLogo);
export default __webpack_public_path__ + "static/media/gemini-logo.1ca17489e9e1c7b698a38ca307521d87.svg";
export { ForwardRef as ReactComponent };